import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import clientConfig from 'clientConfig';
import { consoleLogger } from 'helpers';
import { Auth } from 'aws-amplify';
import PropTypes from 'prop-types';
import VersionForm from 'components/srv/file/version/versionForm';
import Message from 'components/parts/message';
import UnitLoading from 'components/parts/loading/unitLoading';
import { setBreadcrumb } from 'actions/breadcrumbAction';
import { setLoading, clearLoading } from 'actions/loadingAction';
import { clearMessage, setMessage} from 'actions/messageAction';
import { lang } from 'lang';

/**
 * バージョン編集画面
 */
const SrvVersionEdit = (props) => {
  const dispatch = useDispatch();
  const { msg, error } = lang;
  const { id } = props.match.params;
  const { register, handleSubmit, formState, errors } = useForm({mode: 'onChange'});
  const [ versionState, setVersion ] = React.useState({});
  // リクエストキャンセルトークンを取得
  const cancelToken = axios.CancelToken.source();
  const header = useSelector((state) => state.header);

  // ブラウザでコンポーネントが初めて表示される時だけ実行される(≒componentDidMount)
  React.useEffect(() => {
    // メッセージクリア
    dispatch(clearMessage());
    // パンくずリストにプロダクトコードをセット
    dispatch(setBreadcrumb(id));
    Auth.currentSession().then(async currentSession => {
      dispatch(setLoading('unit'));
      const url = clientConfig['api_url'] + '/srv/versions/' + id;
      const requestData = {
        method: 'get',
        url: url,
        headers: { 'Authorization': currentSession.idToken.jwtToken },
        cancelToken: cancelToken.token
      };
      await axios(requestData).then(res => {
        consoleLogger('API GET:' + url);
        consoleLogger(res);
        // Success
        if (res.status === 200) {
          setVersion({
            ...res.data.Item.version,
            open_flg: res.data.Item.version.open_flg === '0' ? false : true
          });
        // Error
        } else {
          dispatch(setMessage('danger', error.version.get + `\n${res.data.errcode}`));
        }
      }).catch(err => {
        consoleLogger(err);
        if (axios.isCancel(err)) {
          return false;
        }

        if (err.response === undefined) {
          dispatch(setMessage('danger', error.version.get + `\n${err.message}`));
        } else {
          // Not Found
          if (err.response.status === 404 && err.response.data.errcode === 'ITEM_NOT_FOUND') {
            dispatch(setMessage('info', msg.version.not_exist));
          // Error
          } else {
            dispatch(setMessage('danger', error.version.get + `\n${err.response.data.errcode}`));
          }
        }
      });
      dispatch(clearLoading());
    }).catch((err) => {
      consoleLogger(err);
      dispatch(setMessage('danger', error.version.get));
    });
    return () => {
      // unmounted component時にコールされる
      cancelToken.cancel('unmounted component.');
    };
  }, [header.mail]);

  // バージョンが存在しない場合
  if (Object.keys(versionState).length === 0) {
    return <div className="col-10 pt-3 pb-3"><UnitLoading/><Message/></div>;
  } else {
    // 更新ボタンが押されたときに実行される
    const onSubmit = async params => {
      // メッセージクリア
      dispatch(clearMessage());

      const currentSession = await Auth.currentSession();
      const url = clientConfig['api_url'] + '/srv/versions/' + id;
      const requestData = {
        method: 'put',
        url: url,
        headers: { 'Authorization': currentSession.idToken.jwtToken },
        params: {
          update_mode: '1',
          update_info: params.update_info
        }
      };
      await axios(requestData)
        .then(res => {
          consoleLogger('API PUT:' + url);
          consoleLogger(res);
          if (res.status === 200) {
            props.history.push({
              pathname: '/srv/files',
              state: { 
                keepMessage: true,  // 一覧画面表示時にメッセージを残す
                message: {
                  type: 'success',
                  msg: msg.version.update
                }
              }
            });
          // Error
          } else {
            dispatch(setMessage('danger', error.version.update + `\n${res.data.errcode}`));
          }
        }).catch(err => {
          consoleLogger(err.response);
          if (err.response === undefined ) {
            dispatch(setMessage('danger', error.version.update + `\n${err.message}`));
          } else {
            // Not Found
            if (err.response.status === 404 && err.response.data.errcode === 'ITEM_NOT_FOUND') {
              dispatch(setMessage('danger', msg.version.not_exist));
            // Error
            } else {
              dispatch(setMessage('danger', error.version.update + `\n${err.response.data.errcode}`));
            }
          }
        });
    };
    return (
      <> 
        <div className="col-10 pt-3 pb-3">
          <Message/>
          <VersionForm isUpdate={true} register={register} values={versionState} onSubmit={handleSubmit(onSubmit)} formState={formState} errors={errors}/>
          <UnitLoading/>
        </div>
      </>
    );
  }
};
SrvVersionEdit.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object
};
SrvVersionEdit.defaultProps = {
  match: {
    params: {
      id: '',
    }
  }
};
export default SrvVersionEdit;